import React from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Paper,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    background: `linear-gradient(135deg, ${theme.palette.primary.light}, #f5f5f5)`,
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 480,
    margin: "0 auto",
    textAlign: "center",
    boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  message: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
}));

const AccessBlocked = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleBackToLogin = () => {
    history.push("/login");
  };

  return (
    <div className={classes.root}>
      <Container>
        <Paper className={classes.paper}>
          <Typography variant="h5" className={classes.title}>
            {i18n.t("accessBlocked.title")}
          </Typography>
          <Typography variant="body1" className={classes.message}>
            {i18n.t("accessBlocked.message")}
          </Typography>
          <Button variant="contained" color="primary" onClick={handleBackToLogin}>
            {i18n.t("accessBlocked.button")}
          </Button>
        </Paper>
      </Container>
    </div>
  );
};

export default AccessBlocked;
